import React from "react";
import { Pressable, Text, View } from "react-native";
import { ViewProps } from "react-native-svg/lib/typescript/fabric/utils";
import { Link, useRouter } from "expo-router";

import { cn } from "~/lib/utils";

export function ListContainer(props: {
  children: React.ReactNode;
  title?: React.ReactNode;
  className?: string;
}) {
  return (
    <View className={cn("gap-y-3", props.className)}>
      {(() => {
        if (!props.title) return null;
        if (typeof props.title === "string")
          return <ListContainerTitleText>{props.title}</ListContainerTitleText>;
        return props.title;
      })()}

      <View className="bg-surface-tertiary overflow-hidden rounded-lg">
        {React.Children.map(props.children, (child, i) => {
          const isLast = React.Children.count(props.children) - 1 === i;

          return (
            <React.Fragment>
              {child}
              {isLast ? null : <View className="border-grey-dark-5 border-b" />}
            </React.Fragment>
          );
        })}
      </View>
    </View>
  );
}

// TODO: Using our own Link cuz expo fkin sucks
// (its Link doesnt handle onPress correctly)
export function MyLink(
  props: React.ComponentPropsWithoutRef<typeof Link>,
  // & {
  //   activeClassName?: string;
  // },
) {
  const { push, replace } = useRouter();
  // const pathname = usePathname();
  // const isActive = resolveHref(props.href)
  //   .replaceAll(/\/\([^)]+\)/g, "")
  //   .startsWith(pathname);

  return (
    <Link
      {...props}
      // className={cn(props.className, isActive ? props.activeClassName : "")}
      role="link"
      onPress={(e) => {
        if (props?.onPress?.(e)) {
          return;
        }

        e.preventDefault();
        if (props.replace) {
          replace(props.href);
        } else {
          push(props.href);
        }
      }}
    />
  );
}

export function ListItem({
  asChild,
  children,
  ...props
}:
  | (ViewProps & { asChild?: boolean })
  | React.ComponentPropsWithRef<typeof MyLink>) {
  // TODO: This component seems a bit weird, maybe we can do better?
  // Revisit later

  if ("href" in props) {
    return (
      <MyLink asChild {...props}>
        <Pressable className="flex-row items-center justify-between px-4 py-3">
          {children}
        </Pressable>
      </MyLink>
    );
  }

  if (asChild) {
    const child = React.Children.only(children);

    if (!React.isValidElement(child)) return null;

    return React.cloneElement(child, {
      ...props,
      // @ts-expect-error ...
      className: "flex-row items-center justify-between px-4 py-3",
    });
  }

  return (
    <View
      className="flex-row items-center justify-between px-4 py-3"
      {...props}
    >
      {children}
    </View>
  );
}

export function ListContainerTitleText(props: { children: React.ReactNode }) {
  return (
    <Text className="text-text-tertiary text-sm font-semibold uppercase">
      {props.children}
    </Text>
  );
}
